module.exports = __webpack_public_path__ + "static/children-a491add68027604d5384a1349155cf60.jpg";